export default __webpack_public_path__ + "static/media/Americana@3x.e958f2ae.png";